/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ServiceOrderAttachmentResponse } from '../types/ServiceOrderAttachment';

export type ServiceOrdersAttachmentsCreateRequest = {} | null | undefined;
export type ServiceOrdersAttachmentsCreateResponse = ServiceOrderAttachmentResponse;

export type ServiceOrdersAttachmentsCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this service order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/service_orders/{id}/attachments/
 *
 * ```yaml
 * operationId: service_orders_attachments_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderAttachment'
 *     description: ''
 * ```
 */
export const serviceOrdersAttachmentsCreateOperation = ({
  id,
  ...rest
}: ServiceOrdersAttachmentsCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/service_orders/${id}/attachments/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/service_orders/{id}/attachments/' };
  };

/**
 * POST /dmx-server/service_orders/{id}/attachments/
 *
 * ```yaml
 * operationId: service_orders_attachments_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentUpload'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderAttachment'
 *     description: ''
 * ```
 */
export const serviceOrdersAttachmentsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ServiceOrdersAttachmentsCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ServiceOrderAttachmentResponse>> => {
  const operation = serviceOrdersAttachmentsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
